module.exports = __webpack_public_path__ + "static/img/14000309.f94368f3.png";